import { PaginationProps } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';
import Loading from 'components/common/Loading';

import { useQuery } from 'react-query';
import { GET } from 'utils';
import { api } from 'utils/apiRoutes';
type dataType = {
  absence_type__name: string;
  absence_type_id: number;
  end_date: string;
  id: number;
  processed_by__full_name: string;
  start_date: string;
  status: string;
  working_days: number;
};
const StaffLeaveAbsenceHistory = ({ id }: { id: number }) => {
  const { data, status } = useQuery('get-absence-history', async () => {
    return await GET(`${api.absence_history}?user_id=${id}`);
  });

  const columns: ColumnsType<dataType> = [
    {
      title: <p style={{ fontSize: '14px', color: '#000', fontWeight: '600px' }}>Start Date</p>,
      dataIndex: 'start_date',
      key: 'start_date',
    },
    {
      title: <p style={{ fontSize: '14px', color: '#000', fontWeight: '600px' }}>End Date</p>,
      dataIndex: 'end_date',
      key: 'end_date',
    },
    {
      title: <p style={{ fontSize: '14px', color: '#000', fontWeight: '600px' }}>Absence Duration</p>,
      dataIndex: 'working_days',
      key: 'working_days',
      render: (_) => <p style={{ color: '#000', fontSize: '12px' }}>{_} d</p>,
    },
    {
      title: <p style={{ fontSize: '14px', color: '#000', fontWeight: '600px' }}>Absence Type</p>,
      dataIndex: 'absence_type__name',
      key: 'absence_type__name',
    },
    {
      title: <p style={{ fontSize: '14px', color: '#000', fontWeight: '600px' }}>To be processed by</p>,
      dataIndex: 'processed_by__full_name',
      key: 'processed_by__full_name',
    },
    {
      title: <p style={{ fontSize: '14px', color: '#000', fontWeight: '600px' }}>Status</p>,
      dataIndex: 'status',
      key: 'status',
      render: (_) => (
        <>
          {
            {
              to_be_approved: (
                <p style={{ color: '#2C5EE0', fontWeight: 600, fontSize: 12 }}>
                  To Be Approved
                </p>
              ),
              approved: (
                <p style={{ color: '#26BE48', fontWeight: 600, fontSize: 12 }}>
                  Approved
                </p>
              ),
              rejected: (
                <p style={{ color: '#E02C2C', fontWeight: 600, fontSize: 12 }}>
                  Reject
                </p>
              ),
              cancelled: (
                <p style={{ color: '#E02C2C', fontWeight: 600, fontSize: 12 }}>
                  Cancelled
                </p>
              ),
            }[_]
          }
        </>
      ),
    },
  ];

  const tableData = data?.data.results.map((item: dataType) => ({
    start_date: (
      <span
        style={{
          fontSize: 12,
          fontWeight: 400,
          color: '#000'
        }}
      >
        {item.start_date}
      </span>
    ),
    end_date: (
      <span
        style={{
          fontSize: 12,
          fontWeight: 400,
          color: '#000'
        }}
      >
        {item.end_date}
      </span>
    ),
    working_days: (
      <span
        style={{
          fontSize: 12,
          fontWeight: 400,
          color: '#000'
        }}
      >
        {item.working_days}
      </span>
    ),
    absence_type__name: (
      <span
        style={{
          fontSize: 12,
          fontWeight: 400,
          color: '#000'
        }}
      >
        {item.absence_type__name}
      </span>
    ),
    processed_by__full_name: (
      <span
        style={{
          fontSize: 12,
          fontWeight: 400,
          color: '#000'
        }}
      >
        {item.processed_by__full_name}
      </span>
    ),
    status: item.status,
  }));

  const itemRender: PaginationProps['itemRender'] = (
    _,
    type,
    originalElement,
  ) => {
    if (type === 'prev') {
      return <a className="mr-3">Previous</a>;
    }
    if (type === 'next') {
      return <a className=" ml-3" style={{ fontSize: '12px' }}>Next</a>;
    }

    return originalElement;
  };
  if (status === 'loading') return <Loading />;
  return (
    <div className="mt-6 staff_leave_footer history_table">
      <div className="has-text-centered py-4" style={{ background: '#EAF6FF' }}>
        <h1 style={{ color: '#000', fontSize: '1rem', fontWeight: 600 }}>
          Staff leave and absence requests
        </h1>{' '}
      </div>
      <Table
        dataSource={tableData}
        columns={columns}
        pagination={{
          defaultPageSize: 10,
          position: ['bottomCenter'],
          itemRender: itemRender,
          style: {
            fontSize: 12,
          },
        }}
      />
    </div>
  );
};

export default StaffLeaveAbsenceHistory;
